import {countryNameToAbbv} from './countryNames'
import {stateNameToAbbv} from './stateNames'
import {provinceNameToAbbv} from './provinceNames'


export function abbvCountry(countryName){
  return countryName ? countryNameToAbbv[countryName.toLowerCase()] || countryName : null;
}

export function abbvRegion(countryAbbv, regionName){
  return regionName ?
        countryAbbv === 'US' ? stateNameToAbbv[regionName.toLowerCase()] || regionName
        : countryAbbv === 'CA' ? provinceNameToAbbv[regionName.toLowerCase()] || regionName
        : regionName
      : null;
}

export function abbvLocation(location){
  let cabbv = abbvCountry(location ? location.country : null);
  return [
    location ? location.locality : null,
    abbvRegion(cabbv, location ? location.region : null),
    cabbv
  ].filter(item => !!item).join(', ');
}
